module.exports = __webpack_public_path__ + "media/base/bar_chart-bc5ff3ca.svg";